// Simple i18n helper for the Materiaal Maatjes plugin
// Usage:
//   import { t, setLocale, getLocale } from '../i18n'
//   t('some.key')

import nl from './nl'

const dictionaries = {
  nl,
}

let currentLocale = 'nl'

export function setLocale(locale) {
  if (dictionaries[locale]) currentLocale = locale
}

export function getLocale() {
  return currentLocale
}

function get(obj, path) {
  const parts = String(path || '').split('.')
  let cur = obj
  for (const p of parts) {
    if (cur && typeof cur === 'object') {
      // Case-insensitive lookup
      const foundKey = Object.keys(cur).find(k => k.toLowerCase() === p.toLowerCase())
      if (foundKey) {
        cur = cur[foundKey]
      } else {
        return undefined
      }
    } else {
      return undefined
    }
  }
  return cur
}

export function t(key, replacements = {}) {
  const dict = window.materiaalI18n || dictionaries[currentLocale] || {}
  const val = get(dict, key)

  let result = typeof val === 'string' ? val : key

  if (typeof result === 'string' && replacements) {
    Object.keys(replacements).forEach(k => {
      result = result.replace(`{${k}}`, replacements[k])
    })
  }

  return result
}

export default { t, setLocale, getLocale }
